import React, { useState } from 'react';
import { Box, ClickAwayListener, Slide } from '@mui/material';
import SidebarPOS from './SidebarPos';
import { Outlet } from 'react-router-dom'; // ✅ import this

const LayoutPOS = ({ onClose }) => {
  const [open, setOpen] = useState(true);

  const user = JSON.parse(localStorage.getItem("userDetails")) || {};
  const role = user.role_name;

  const handleClose = () => setOpen(false);

  const handleExited = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  if (role !== "User Franchise") return null;

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Sidebar */}
      <ClickAwayListener onClickAway={handleClose}>
        <Slide
          direction="right"
          in={open}
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={handleExited}
        >
          <Box
            sx={{
              width: "265px",
              height: '100vh',
              backgroundColor: '#fff',
              boxShadow: 3,
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: 1300,
              borderTopRightRadius: '16px',
            }}
          >
            <SidebarPOS />
          </Box>
        </Slide>
      </ClickAwayListener>

      {/* Page content */}
     {/* <Box sx={{ ml: open ? '265px' : 0, flexGrow: 1, width: '100%' }}> */}
        <Box sx={{ flexGrow: 1, width: '100%' }}>
  <Outlet />
</Box>

    </Box>
  );
};

export default LayoutPOS;

